<template>
    <div id="wrapper">
        <SidebarView :coaReconsile="true" :accounts="true" :accounts-visible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />

                <div class="container-fluid">
                    <div class="row">
                        <div class="py-3 d-flex flex-row align-items-center justify-content-between">
                            <div class="col-12">
                                <div class="card card-shape home-box">
                                    <div class="card-header d-flex flex-row align-items-center">
                                        <h6 class="m-0 fw-bold text-green">Merge COA</h6>
                                    </div>
                                    <div class="card-body">
                                        <form class="form" @submit.prevent="storeData">
                                            <div class="row">
                                                <!-- <div class="err-accounts">
                                                    <errors v-if="form.errors.accounts">
                                                        {{ form.errors.accounts[0] }}
                                                    </errors>
                                                </div> -->
                                                <div class="row mt-2">
                                                    <div class="col">
                                                        <b-form-group>
                                                            <label class="akkurate-dark small" for="from_coa">From COA
                                                                <star></star>
                                                            </label>
                                                            <multiselect v-model="form.from_code" name="from_coa"
                                                                :options="coaSubheadOptions"
                                                                class="mt-2 field-container" label="code"
                                                                :custom-label="customLabel" required>
                                                            </multiselect>
                                                            <errors v-if="form.errors.from_coa">
                                                                {{ form.errors.from_coa[0] }}
                                                            </errors>
                                                        </b-form-group>
                                                    </div>

                                                    <div class="col">
                                                        <b-form-group>
                                                            <label class="akkurate-dark small" for="to_coa">To COA
                                                                <star></star>
                                                            </label>
                                                            <multiselect v-model="form.to_code" name="to_coa"
                                                                :options="coaSubheadOptions"
                                                                class="mt-2 field-container" label="code"
                                                                :custom-label="customLabel" required>
                                                            </multiselect>
                                                            <errors v-if="form.errors.to_coa">
                                                                {{ form.errors.to_coa[0] }}
                                                            </errors>
                                                        </b-form-group>
                                                    </div>


                                                </div>
                                                <!-- <hr class="my-4" /> -->
                                                <!-- Displaying Total Debit and Total Credit -->

                                                <p class="akkurate-danger small">{{ acc_error }}</p>

                                            </div>
                                            <hr />
                                            <div class="text-center py-3">
                                                <SaveButton :isSaving="isSaving" />
                                                <button type="reset" @click="resetForm"
                                                    class="btn akkurate-gray-btn text-white btn-size my-2 ms-3">
                                                    <font-awesome-icon class="me-2" :icon="['fas', 'rotate-right']" />
                                                    Reset
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>
        <!-- AI -->
         <ChatBot />
        <!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import Multiselect from 'vue-multiselect';
import ApiService from "@/core/services/api.service";
import SaveButton from "@/views/main/components/SaveButton.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
    name: 'COAReconciliationEntry',
    components: {
        SidebarView,
        TopbarView,
        Footer,
        Multiselect,
        SaveButton,
        ChatBot,
    },
    mounted() {
        let token = localStorage.getItem('token');
        if (!token) {
            this.$router.push({ path: '/login' });
        }
        this.coa_dropdown();
    },
    data() {
        return {
            ...this.initialState(),
            coaSubheadOptions: [],
            errors: [],
            isSaving: false,
            acc_error: ""
        }
    },
    // watch: {
    //     selectedCoaSubhead(newVal) {
    //         this.form.coa_subhead_code = newVal ? newVal.code : "";
    //     }
    // },
    // computed: {
    //     totalDebit() {
    //         return this.entities.reduce((sum, field) => sum + parseFloat(field.dr_amount || 0), 0);
    //     },
    //     totalCredit() {
    //         return this.entities.reduce((sum, field) => sum + parseFloat(field.cr_amount || 0), 0);
    //     }
    // },
    methods: {

        // drDisabled(field) {
        //     if (field.cr_amount.length > 0) {
        //         field.dr_amount = 0;
        //         return true;
        //     }
        // },
        // crDisabled(field) {
        //     if (field.dr_amount.length > 0) {
        //         field.cr_amount = 0;
        //         return true;
        //     }
        // },
        coa_dropdown() {
            this.isSaving = true;
            this.$Progress.start();
            ApiService.post("/finance/chart-of-accounts/subhead/dropdown")
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.coaSubheadOptions = response.data.coa_subheads
                })

        },
        // addAccount() {
        //     if (this.entities.length < 1) {
        //         this.acc_error = "account can not be lesser then one"
        //         // this.isSaving = true
        //     } else {
        //         this.acc_error = ""
        //         // this.isSaving = false
        //     }
        //     if (this.entities.length > 0) {
        //         this.entities.push({ amount: "", coa_subhead: { id: "", name: "", code: "" } });

        //     }
        // },
        // removeField(index) {
        //     if (this.entities.length == 1) {
        //         this.acc_error = "account can not be lesser then one"
        //         // this.isSaving = true

        //     } else {
        //         this.acc_error = ""
        //         // this.isSaving = false
        //     }
        //     if (this.entities.length > 1) {
        //         this.entities.splice(index, 1);
        //     }
        // },
        storeData() {
            this.isSaving = true;
            this.$Progress.start();

            console.log(this.form);

            ApiService.post("/finance/chart-of-accounts/merge-coa-code", this.form)
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();

                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });

                    this.resetForm();
                })
                .catch((error) => {
                    console.log(error);
                    this.isSaving = false;
                    this.$Progress.fail();
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors;
                    }
                });
        },
        resetForm() {
            this.form = this.initialState().form;
            this.entities = [{ amount: "", coa_subhead: { id: "", name: "", code: "" } }];
            // this.selectedCoaSubhead = this.initialState().selectedCoaSubhead;
            this.errors = [];
        },
        initialState() {
            return {
                form: {
                    from_code: [],
                    to_code:[],
                    errors: [],
                    trans_date: "",
                },
                entities: [{ amount: "", coa_subhead: { id: "", name: "", code: "" } }],
            }
        },
        customLabel({ code, name, coabranch }) {
            return `${code} - ${name} - ${coabranch?.name ?? ""}`
        }
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>